import styled from 'styled-components';
import { CropwiseGreen, MediaQuery, NeutralColors } from 'theme';

const shimmer = `
  @keyframes shimmer {
    0% {
      opacity: 1;
      box-shadow: inset 0 0 10px rgba(255, 255, 255, 0.3);
    }
    50% {
      opacity: 0.7;
      box-shadow: inset 20px 0 20px rgba(255, 255, 255, 0.5);
    }
    100% {
      opacity: 1;
      box-shadow: inset 0 0 10px rgba(255, 255, 255, 0.3);
    }
  }
`;

const ProgressWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

const ProgressBar = styled.div`
  width: 100%;
  height: 7px;
  background-color: ${NeutralColors[20]};
  overflow: hidden;

  ${shimmer}

  &::after {
    content: '';
    display: block;
    height: 100%;
    background-color: ${CropwiseGreen};
    border-radius: 0 24px 24px 0;
    width: ${(props: { percentage: number }) => `${props.percentage}%`};
    min-width: 3%;
    transition: width 0.6s ease;
    animation: shimmer 2s ease-in-out infinite;
  }
`;

const ContentLayout = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
  height: 100%;

  @media (max-width: ${MediaQuery.screenSizesCss.phone}) {
    flex-direction: column;
    overflow-y: auto;
  }
`;

const LeftContent = styled.div`
  flex: 1;
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (max-width: ${MediaQuery.screenSizesCss.phone}) {
    padding: 24px 16px;
  }
`;

const SceneImage = styled.div`
  width: 100%;
  height: 240px;
  background-position: center;
  background-size: cover;
  border-radius: 8px;
  overflow: hidden;
`;

const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const RightContent = styled.div`
  width: 460px;
  background-color: ${NeutralColors[10]};
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;

  @media (max-width: ${MediaQuery.screenSizesCss.phone}) {
    width: 100%;
    padding: 24px 16px;
    overflow-y: visible;
  }
`;

export {
  ContentLayout,
  LeftContent,
  ProgressBar,
  ProgressWrapper,
  RightContent,
  SceneImage,
  TitleSection,
};
